// src/common/BellDropdown.tsx
import React from "react";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
} from "../../components/ui/dropdown-menu";
import { Bell } from "lucide-react";
import { useNotifications } from "../../context/NotificationContext";
import { Button } from "../../components/ui/button";

const BellDropdown = () => {
    const {
        notifications,
        unreadCount,
        markAsRead,
        markAllAsRead,
        fetchNotifications,
    } = useNotifications();

    return (
        <DropdownMenu onOpenChange={(open) => open && fetchNotifications()}>
            <DropdownMenuTrigger asChild>
                <div className="relative cursor-pointer">
                    <Button variant="ghost" size="icon">
                        <Bell className="h-5 w-5 text-gray-700 dark:text-gray-200" />
                    </Button>
                    {unreadCount > 0 && (
                        <span className="absolute top-0 right-0 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white dark:ring-gray-800 animate-ping" />
                    )}
                </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto">
                {notifications.length === 0 ? (
                    <DropdownMenuItem disabled>No notifications</DropdownMenuItem>
                ) : (
                    <>
                        {notifications.map((n) => (
                            <DropdownMenuItem
                                key={n.id}
                                className={`flex flex-col space-y-1 ${
                                    n.is_read ? "opacity-60" : "font-semibold"
                                }`}
                                onSelect={() => markAsRead(n.id)}
                            >
                                <span>{n.title}</span>
                                <span className="text-xs text-muted-foreground">
                  {n.message}
                </span>
                            </DropdownMenuItem>
                        ))}
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onSelect={markAllAsRead}>
                            Mark all as read
                        </DropdownMenuItem>
                    </>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default BellDropdown;
